export class OrderDateCriteria {
  constructor(
    public dateCriteriaTypes: OrderDateCriteriaFilter[],
    public startDate?: Date,
    public endDate?: Date
  ) {}
}

export enum OrderDateCriteriaFilter {
  Created = 'Created',
  Updated = 'Last Updated',
  Cancelled = 'Cancelled',
  Returned = 'Returned',
  Placed = 'Placed',
  Processing = 'Processed',
  Accepted = 'Accepted',
  Loading = 'Loaded',
  Dispatched = 'Dispatched',
  Fulfilled = 'Fulfilled',
}
